var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuLightE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136.882,
    height: 149.795,
    viewBox: "0 0 136.882 149.795",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(592 421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M0,0H136.882V32.514H0Z",
    transform: "translate(-592 -362.36)",
    fill: "#449400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M0,0H136.882V32.514H0Z",
    transform: "translate(-592 -421)",
    fill: "#fd5b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M0,0H136.882V37.105H0Z",
    transform: "translate(-592 -308.311)",
    fill: "#449400"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLightE);
export default __webpack_public_path__ + "static/media/menu-light-e.05510dbecda4c4b2107c93e66be10511.svg";
export { ForwardRef as ReactComponent };